<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { computed, useAttrs } from "vue"
import { cn } from "@/shared/lib/utils"

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  invalid?: boolean
  placeholder?: string
  disabled?: boolean
  rows?: number
  class?: HTMLAttributes["class"]
}>()

const model = defineModel<string>({ default: "" })
const attrs = useAttrs()

const ariaInvalid = computed<true | undefined>(() => {
  if (props.invalid)
    return true
  const a = attrs["aria-invalid"]
  return a === true || a === "" || a === "true" ? true : undefined
})
</script>

<template>
  <textarea
    v-bind="attrs"
    v-model="model"
    data-slot="textarea"
    :rows="rows ?? 3"
    :placeholder="placeholder"
    :disabled="disabled"
    :aria-invalid="ariaInvalid"
    :data-invalid="ariaInvalid"
    :class="
      cn(
        'border-input bg-background placeholder:text-muted-foreground dark:bg-input/30 flex min-h-[80px] w-full rounded-md border px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none resize-y disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        props.class,
      )
    "
  />
</template>
